import Auth from 'layout/auth.layout';
import Main from 'layout/main.layout';
import Dashboard from 'pages/auth/Dashboard';
import AcceptDeal from 'pages/auth/AcceptDeal';
import InviteUser from 'pages/auth/InviteUser';
import RequestFunds from 'pages/auth/RequestFunds';
import SendFunds from 'pages/auth/SendFunds';
import TransactionDetails from 'pages/auth/TransactionDetails';
import Transactions from 'pages/auth/Transactions';
import TransferPayment from 'pages/auth/TransferPayment';
import ViewDetails from 'pages/auth/ViewDetails';
import GetStarted from 'pages/nonauth/GetStarted';
import Login from 'pages/nonauth/Login';
import Registration from 'pages/nonauth/Registration';
import TwoFactor from 'pages/onboarding/TwoFactor';
import Verification from 'pages/onboarding/Verification';
import VerificationPrompt from 'pages/onboarding/VerificationPrompt';
// import Login from "pages/nonauth/Login";
// import { Home, Deals, NotFound } from 'pages';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RouteGuard } from './RouteGuard';
import Onboarding from 'layout/onboarding.layout';
import ChangeEmailMobile from 'pages/auth/ChangeEmailMobile';
import ForgotPassword from 'pages/nonauth/ForgotPassword';
import ChangePassword from 'pages/auth/ChangePassword';
import TwoFactorMobile from 'pages/onboarding/TwoFactorMobile';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <RouteGuard>
              <Main />
            </RouteGuard>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="home" element={<Dashboard />} />
          <Route path="send-funds" element={<SendFunds />} />
          <Route path="request-funds" element={<RequestFunds />} />
          <Route path="transaction-details" element={<TransactionDetails />} />
          <Route path="transfer-payment" element={<TransferPayment />} />
          <Route path="invite-user" element={<InviteUser />} />
          <Route path="accept-deal" element={<AcceptDeal />} />
          <Route path="transactions" element={<Transactions />} />
          <Route path="account" element={<ViewDetails />} />
          <Route
            path="change-email"
            element={<ChangeEmailMobile mode="email" />}
          />
          <Route
            path="change-mobile"
            element={<ChangeEmailMobile mode="mobile" />}
          />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>
        <Route path="/" element={<Onboarding />}>
          <Route path="two-factor" element={<TwoFactor />} />
          <Route path="two-factor-mobile" element={<TwoFactorMobile />} />
          <Route path="verification-prompt" element={<VerificationPrompt />} />
          <Route path="verification" element={<Verification />} />
        </Route>
        <Route path="/" element={<Auth />}>
          <Route index element={<GetStarted />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Registration />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
        </Route>

        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
